
module.exports = class ToolchestChairButton extends React.Component
  displayName: 'ToolchestChairButton'

  constructor: (props) ->
      super(props)
      # Expects: @props.
      # my_accepted_roles
      @state = { }

  render: =>

      if @props.tool_selected is 'chair_tools'
          card_className = 'card light_green'
      else
          card_className = 'card light_gray'

      <div className={card_className}>
        <div className="card-body">
            <h2 className="card-title">
                <button className='btn btn-primary'
                        onClick={ @props.onClick.bind(this, {tools: 'chair_tools', show_this: 'chair_tools'}) }>
                    chair tools
                </button>
            </h2>
            <p className="card-text">
                Use the chair tools.
            </p>
        </div>
      </div>
